import { Environment, EnvironmentNameEnum } from '@shared/client/models/environment.interface';

export interface ConnectServicesEnvironment extends Environment {
    baseWebsocketPath: string;
    baseWebsocketUrl: string;
    googleMapsApiKey: string;
    panoramaxUrl: string;
}

export const defaultEnvironment: ConnectServicesEnvironment = {
    baseApiUrl: 'http://localhost:80',
    baseWebsocketPath: '/',
    baseWebsocketUrl: 'ws://localhost:3001',
    env: EnvironmentNameEnum.DEV,
    googleMapsApiKey: 'AIzaSyBMeOrir_yLvxGar4w64blBvXhBeLfTCIY',
    panoramaxUrl: 'https://api.panoramax.xyz/api',
    production: false,
    sentryUrl: 'https://06bb0980534f409abe915584b7932c36@o131322.ingest.sentry.io/6765970',
};
